import React from 'react';

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className="px-4 py-3 rounded-lg text-xs bg-[#ffe4e6] border border-[#fecdd3] text-[#dc2626] mt-4">
      {message}
    </div>
  );
};

export default ErrorMessage;

